import React, { useEffect, useState } from "react";
import { Result, Spin } from "antd";
import { axiosInstance } from "@/utilities";
import { API_URL_PIM_ATTRIBUTES } from "@/services/XCONS_ENV";

/**
 * **Si quien mira entra a la sección Atributos** (xcons-docs#478). No depende del nivel del
 * Catálogo: es un permiso aparte, sí/no, que se da en la base. Se pregunta al API y no a la
 * identidad, que es una foto del login y no lo trae. `null` mientras pregunta; si la pregunta
 * falla, no se muestra (el API corta igual).
 */
export const useSeccionDeAtributos = (): boolean | null => {
  const [puede, setPuede] = useState<boolean | null>(null);
  useEffect(() => {
    let vigente = true;
    axiosInstance
      .get<{ canManageAttributes: boolean }>(`${API_URL_PIM_ATTRIBUTES}/access`)
      .then(({ data }) => vigente && setPuede(Boolean(data?.canManageAttributes)))
      .catch(() => vigente && setPuede(false));
    return () => {
      vigente = false;
    };
  }, []);
  return puede;
};

/**
 * Las pantallas de Atributos y Conjuntos, sólo con el permiso (xcons-docs#478). Sin él, un 403
 * que dice por qué en vez de una tabla vacía o errores sueltos: la lista de atributos la puede
 * leer un Editor —la usa el importador—, así que sin esto la pantalla se veía a medias.
 */
export const SoloConSeccionDeAtributos: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const puede = useSeccionDeAtributos();
  if (puede === null) return <Spin style={{ display: "block", margin: "48px auto" }} />;
  if (!puede) {
    return (
      <Result
        status="403"
        title="No tenés acceso a Atributos"
        subTitle="La sección Atributos pide un permiso aparte del nivel del Catálogo. Lo da un administrador del sistema."
      />
    );
  }
  return <>{children}</>;
};
